import { createSelector } from "reselect";
import { ICanvasEditorState } from "../interfaces/model/CanvasEditorState";
import { IPage } from "../interfaces/model/Page";

/**
 * Get all Pages from state
 * @param state {ICanvasEditorState} - The redux state
 * @returns {Pages[]} Page array with Pages. Empty array if there is no page
 */
const pages = (state: ICanvasEditorState) => state.pages;

const pagesSelector = createSelector([pages], (pagesList) => {
	return pagesList;
});

/**
 * Get selected page index from selection (1 based)
 * @param state {ICanvasEditorState} - The redux state
 * @returns {number | undefined} Selected page index or undefined if there is no
 * 		page selection
 */
const selectedPageSelector = (state: ICanvasEditorState): number | undefined => state.selection.present.selectedPage;

/**
 * Get selected Page
 * @param State {ICanvasEditorState}
 * @param selectedPage {number | undefined} Selected page index
 * @returns {IPage} Selected Page object
 */
const _getSelectedPage =
    (pagesState: ICanvasEditorState["pages"], selectedPage: number | undefined): IPage | null => {
    	if (selectedPage !== undefined && pagesState.present.length && pagesState.present[selectedPage - 1]) {
    		return pagesState.present[selectedPage - 1];
    	}
    	return null;
    };

export const getSelectedPage = createSelector([pagesSelector, selectedPageSelector], _getSelectedPage);
